exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slick-next,.slick-prev{font-size:0;line-height:0;position:absolute;top:25%;cursor:pointer;background:none;width:16px;height:16px;border:2px solid #000;border-top:none;border-left:none}.slick-next,.slick-next:focus,.slick-prev,.slick-prev:focus{outline:none}.slick-next{right:-20px;transform:rotate(-45deg)}.slick-prev{left:-20px;transform:rotate(135deg)}.slick-dots{display:none!important}", ""]);

// exports
